import styles from './styles'
import icons from './icons'

export default {
  name: 'algar',
  styles,
  icons,
}



// WEBPACK FOOTER //
// ./src/shared/skin/index.js